import { getApiErrorCode } from './get-api-error-code';

/**
 * Whether a rejected request never got an answer from our backend (NPJB-815): a timeout or
 * network failure (no status), or a gateway 5xx with no backend error envelope.
 *
 * It says nothing about the session. A signed-out `/auth/me` comes back as the backend's
 * `{ code: 'AUTHENTICATION_FAILED' }` envelope, so anything carrying a backend code is an
 * answer, not an outage.
 */
export const isServerUnreachableError = (err: unknown): boolean => {
  if (getApiErrorCode(err)) return false;
  const status = (err as { status?: unknown } | null | undefined)?.status;
  if (status === undefined) return err instanceof Error;
  return typeof status === 'number' && status >= 500;
};
